import type {MemexItemModel} from '../../../models/memex-item-model'
import {rowIsExpanded} from './row-api'
import type {Table, TableInstance} from './types'

const tableGetCollapsedGroupIds = (table: Table<MemexItemModel>) => {
  const groupedRows = tableGetGroupedRows(table)
  return groupedRows?.filter(row => !rowIsExpanded(row)).map(row => row.groupedValue) ?? []
}

export const getIsTableGrouped = (table: Table<MemexItemModel>) => {
  const state = table.getState()
  return state.grouping?.length > 0
}

const tableGetGroupedRows = (table: Table<MemexItemModel>) => {
  const isGrouped = getIsTableGrouped(table)
  // For backwards compatibility with code that expects groupedRows to be undefined when not grouped
  // In v8, getGroupedRowModel().rows is still defined when not grouped
  if (!isGrouped) return undefined
  return table.getGroupedRowModel().rows
}

export const buildTransitionalTableInstance = (table: Table<MemexItemModel>): TableInstance<MemexItemModel> => {
  const {rows, flatRows, rowsById} = table.getRowModel()
  return {
    rows,
    flatRows,
    groupedRows: tableGetGroupedRows(table),
    rowsById,
    visibleColumns: table.getVisibleLeafColumns(),
    totalColumnsWidth: table.getTotalSize(),
    allColumns: table.getAllColumns(),
    headerGroups: table.getHeaderGroups(),
    collapsedGroupIds: tableGetCollapsedGroupIds(table),
  }
}
